"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// A URL encoded checkbox SVG file for which we can specify a fill color. Borrowed from Material UI.
const uncheckedSvg = color => {
  const encodedColor = color === null || color === void 0 ? void 0 : color.toString().replace('#', '%23'); // URL-encode the `#`
  return `%3Csvg xmlns='http://www.w3.org/2000/svg' fill='${encodedColor}' focusable='false' aria-hidden='true' viewBox='0 0 24 24' %3E%3Cpath d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'%3E%3C/path%3E%3C/svg%3E`;
};
var _default = exports.default = uncheckedSvg;